const URL_PATTERN = /(?:https?:\/\/|www\.)[^\s<>"']+/gi
const TRAILING_PUNCTUATION_PATTERN = /[.,!?;:]$/

const countCharacter = (value, character) => {
  return [...value].filter((currentCharacter) => currentCharacter === character).length
}

const splitTrailingUrlText = (value) => {
  let urlText = value
  let trailingText = ''

  while (urlText.length > 0) {
    const lastCharacter = urlText.at(-1)

    if (TRAILING_PUNCTUATION_PATTERN.test(lastCharacter)) {
      trailingText = `${lastCharacter}${trailingText}`
      urlText = urlText.slice(0, -1)

      continue
    }

    if (
      (lastCharacter === ')' && countCharacter(urlText, '(') < countCharacter(urlText, ')'))
      || (lastCharacter === ']' && countCharacter(urlText, '[') < countCharacter(urlText, ']'))
      || (lastCharacter === '}' && countCharacter(urlText, '{') < countCharacter(urlText, '}'))
    ) {
      trailingText = `${lastCharacter}${trailingText}`
      urlText = urlText.slice(0, -1)

      continue
    }

    break
  }

  return {
    urlText,
    trailingText,
  }
}

const buildLinkHref = (urlText) => {
  if (/^https?:\/\//i.test(urlText)) {
    return urlText
  }

  return `https://${urlText}`
}

const pushTextSegment = (segments, text) => {
  if (text === '') {
    return
  }

  const previousSegment = segments.at(-1)

  if (previousSegment?.type === 'text') {
    previousSegment.text += text

    return
  }

  segments.push({
    type: 'text',
    text,
  })
}

export const buildLinkifiedTextSegments = (value) => {
  const text = typeof value === 'string' ? value : ''

  if (text === '') {
    return []
  }

  const segments = []
  const matches = text.matchAll(URL_PATTERN)
  let lastIndex = 0

  for (const match of matches) {
    const matchedText = match[0]
    const matchIndex = match.index ?? 0
    const { urlText, trailingText } = splitTrailingUrlText(matchedText)

    if (urlText === '') {
      continue
    }

    pushTextSegment(segments, text.slice(lastIndex, matchIndex))
    segments.push({
      type: 'link',
      text: urlText,
      href: buildLinkHref(urlText),
    })
    pushTextSegment(segments, trailingText)

    lastIndex = matchIndex + matchedText.length
  }

  pushTextSegment(segments, text.slice(lastIndex))

  return segments
}
